"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEADER_IDS = void 0;
exports.HEADER_IDS = {
    HAMBURGER_BUTTON: 'js-hamburger-button',
    HAMBURGER_OPEN_ICON: 'js-hamburger-open-icon',
    HAMBURGER_CLOSE_ICON: 'js-hamburger-close-icon',
    HAMBURGER_CONTENT: 'js-hamburger-content',
    HAMBURGER_CONTAINER: 'js-hamburger-accordion-container',
};
